export const RouterName = {
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  advocacy: {
    advocacy: "/advocacy",
    advocacyCategory: "/advocacy/category",
  },
  InPress: {
    InPress: "/InPress",
    InPressCategory: "/InPress/category",
  },
  politicalMission: {
    politicalMission: "/politicalMission",
    politicalMissionCategory: "/politicalMission/category",
  },
  publication: {
    publication: "/publication",
  },
  socialInitiatives: {
    socialInitiatives: "/socialInitiatives",
  },
  contact: {
    contact: "/contact",
  },

  admins: {
    admins: "/admins",
    privileges: "/privileges",
  },
  admins_logs: {
    admins_logs: "/admins-logs",
  },

  settings: {
    settings: "/settings",
    legal_information: "/legal_information",
    SEO: "/SEO",
  },
  gallery: {
    gallery: "/gallery/:related_id/:type",
  },
  related_social_initiatives: {
    related_social_initiatives: "/socialInitiatives/:parent_id/related",
  },
  changePassword: {
    changePassword: "/change-password",
  },
};
